// --- NEW FUNCTION DEFINITION: Select Element ARIA Fix (Defined outside the onload handler) ---

/**
 * Iterates over all <select> elements and applies 'aria-label="weight and grind"'
 * if the element does not already have an aria-label.

function addAriaLabelToSelects() {
  const newAriaLabel = "weight and grind";
  const selectElements = document.querySelectorAll('select');
  
  selectElements.forEach(selectElement => {
    const hasAriaLabel = selectElement.hasAttribute('aria-label');
    
    // Only apply the label if one does not already exist
    if (!hasAriaLabel) {
      selectElement.setAttribute('aria-label', newAriaLabel);
      // console.log(`Accessibility Fix: Set aria-label on unlabeled <select> element.`);
    }
  });
}
*/

/**
 * Checks the current URL and executes the specific <select> fix only
 * if the page matches one of the target product pages.
 */
function runConditionalSelectFix() {
    const currentPageUrl = window.location.href;
    
    // Define the specific product paths where this fix is required.
    const targetPaths = [
        "/products/two-coffee-gift-box",
        "/products/2-item-gift-bundle-1"
    ];

    // Check if the current URL contains one of the target product paths
    const shouldRun = targetPaths.some(path => currentPageUrl.includes(path));

    if (shouldRun) {
        // Execute the specific accessibility fix
        addAriaLabelToSelects();
        // console.log("Specific accessibility fix for 'weight and grind' SELECTs executed.");
    }
}


// --- EXISTING WINDOW.ONLOAD HANDLER (Now incorporating the new conditional fix) ---

window.onload = function() {
  // Uses a 2-second delay to ensure dynamic elements (like Rebuy) are loaded.
  setTimeout(function(){
    console.log("Accessibility JavaScript Running");
    
    // --- Existing Rebuy Cart Fixes ---
    let cartOpen = document.querySelector(".rebuy-cart__flyout-close");
    cartOpen.addEventListener("focus", function(){
      let skipIt = document.querySelector(".rebuy-widget-content");
      let checkoutButton = document.querySelector(".rebuy-cart__checkout-button")
      checkoutButton.setAttribute("id","rebuy-cart__checkout-button");
      let skipRecommendations = document.createElement("a");
      skipRecommendations.setAttribute("href","#rebuy-cart__checkout-button");
      skipRecommendations.classList.add("skip-section-link");
      skipRecommendations.textContent = "Skip Recommendations";
      skipIt.prepend(skipRecommendations);
    });
    
    let notHeadings = document.querySelectorAll(".rebuy-product-info a, .rebuy-cart__flyout-item-product-title");
    for (let i = 0; i < notHeadings.length; i++) {
      notHeadings[i].removeAttribute("role");
      notHeadings[i].removeAttribute("aria-level");
    }
    
    let wrongLevel = document.querySelector(".rebuy-cart__flyout-content .primary-title");
    wrongLevel.outerHTML = '<h3>' + wrongLevel.innerHTML + '</h3>';
    
    // --- NEW FIX: Conditional execution for Select ARIA-Label ---
    runConditionalSelectFix();

    // --- Add blank alt to tracking pixel image so it's decorative and ignored by screen readers
    let trackingPixel = document.getElementById("_pxPixel4");
    trackingPixel.setAttribute("alt","")
  },2000)
};